<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Exception Report</strong> 

          </div>
          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Not Assigned</a>
              </li>
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Assigned</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">OFD</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Handover Pending</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 4"  class="nav-link " :class="{'active' : isActiveTab(4)}">RTO</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 5"  class="nav-link" :class="{'active' : isActiveTab(5)}" >Delivered</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 6"  class="nav-link" :class="{'active' : isActiveTab(6)}" >PickCancel </a>
              </li>
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
        
            <div class="tab-panel" v-if="isActiveTab(0)">
              <NotAssigned style="width:70%;"></NotAssigned>
            </div>

            <div class="tab-panel" v-if="isActiveTab(1)">
            <Assigned style="width:70%;"></Assigned>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <Ofd style="width:70%;"></Ofd>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <ndr width=70% ></ndr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(4)">
            <rto width=70% ></rto>
            </div>

            <div class="tab-panel" v-if="isActiveTab(5)">
                <delivered width=70% ></delivered>
            </div>
              <div class="tab-panel" v-if="isActiveTab(6)">
                <pickCancel width=70% ></pickCancel>
            </div>
            <documents v-if="isActiveTab(3)"></documents>
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   

</notassigned-component>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import NotAssigned from './notAssigned.vue'
import PickCancel from './pickCancel.vue'
import Assigned from './assigned.vue'
import Ofd from './ofd.vue'
import delivered from './delivered.vue'
import rto from './rto.vue'
import ndr from './ndr.vue'

export default {
  data: function() {
    return {
      activeTab: 0,
      NotAssigned,
      PickCancel,
      Assigned,
      Ofd,
      id:'',
      delivered,
      rto,
      ndr,
      name: 'exceptionReport'
    };
  },
  components: {
    NotAssigned,
    PickCancel,
    Assigned,
    Ofd,
    delivered,
    rto,
    ndr
  },
  created: function() {
    this.isActiveTab(0);
  },
  methods: {
  	isActiveTab(id)
    {
       return this.activeTab === id
    }
  }
};
</script>
